module.exports = __webpack_public_path__ + "img/touchstart.105ea0e4.svg";